import { PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import { changePhotoVariant, ChangePhotoVariantMethod } from './changePhotoVariant';
import { createGroup } from './createGroup';
import { updateVariant } from './updateVariant';
import { uploadImages } from './uploadImages';

export const saveVariant = (
    config: ChangeVariantConfiguration,
    files: File[] | undefined,
    forceNewGroup: boolean | undefined = false
): PhotoPrintsPdpThunk => {

    const { groupId, photoId, paperId, sizeId, borderId, method } = config;

    return (dispatch, getState) => {

        const state = getState();
        const groupExists = state.project.groups.ids.includes(groupId);

        if (method) {
            dispatch(changePhotoVariant(paperId, sizeId, photoId!, method, forceNewGroup, borderId));
        } else if (groupExists) {
            dispatch(updateVariant(paperId, sizeId, groupId, borderId));
        } else {
            dispatch(createGroup(paperId, sizeId, groupId, borderId));
        }

        if (files) {
            dispatch(uploadImages(files!, groupId));
        }
    };
};

export type ChangeVariantConfiguration = {
    paperId: string;
    sizeId: string;
    photoId?: string;
    groupId: string;
    borderId?: string;
    method?: ChangePhotoVariantMethod;
};